import { httpClient } from '@/libs/axios';

export const LoggerConstant = {
  KYC3: 'Checkin KYC - API',
  Firebase: 'Firebase - API',
}

const Logger = (() => {
  const requestApi = async (value: any) => {
    await httpClient.post('/logging', value);
  };
  return {
    info: async (data: any) => {
      let formData = {
        module: data.module,
        content: JSON.stringify({
          func: data.funcName,
          params: data.params,
        }),
        logging_type: 'info',
      };
      await requestApi(formData);
    },
    debug: async (data: any) => {
      const formData = {
        module: data.module,
        content: JSON.stringify({
          func: data.funcName,
          params: data.params,
        }),
        logging_type: 'debug',
      };
      await requestApi(formData);
    },
    error: async (data: any) => {
      const formData = {
        module: data.module,
        content: JSON.stringify({
          func: data.funcName,
          error: data.error,
        }),
        logging_type: 'error',
      };
      await requestApi(formData);
    },
  };
})();

export { Logger };
